/**
 * Correlate customer-facing errors with backend `ux_http_request` via `X-Request-Id`.
 */

export function readUxRequestId(res: Response | null | undefined): string | undefined {
  const id = res?.headers?.get('x-request-id')?.trim();
  return id || undefined;
}

/** Use when no API response exists (validation, network without Response, etc.). */
export function newClientReferenceId(prefix: string): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

export function buildContactSupportHandoffUrl(params: {
  referenceId: string;
  context: 'checkout' | 'cart' | 'checkout-promo';
}): string {
  const q = new URLSearchParams();
  q.set('ref', params.referenceId);
  q.set('context', params.context);
  q.set('topic', 'online-order-delivery-support');
  return `/contact?${q.toString()}`;
}
